import React, { FunctionComponent } from 'react';
import { isEmpty } from 'ramda';
import { FAQBlock } from '../types';

interface Props {
  blocks: FAQBlock[];
  format?(html: string): string;
  className?: string;
}

export const FAQBlocks: FunctionComponent<Props> = ({ blocks, format = html => html, className }) => {
  return blocks && !isEmpty(blocks) ? (
    <div className={className}>
      {blocks.map((item: FAQBlock) => (
        <React.Fragment key={item.id}>
          <div dangerouslySetInnerHTML={{ __html: format(item.question) }} />
          <div dangerouslySetInnerHTML={{ __html: format(item.answer) }} />
        </React.Fragment>
      ))}
    </div>
  ) : null;
};
